import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { StockItemsService } from '~/services/modules/stocks/items';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PurchaseOrder, PurchaseOrderDetail } from '~/front-models/purchaseOrderGrid';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { WindowService, WindowState } from '@progress/kendo-angular-dialog';
import { AccountsService } from '~/services/administration.ts/accounts';
import { parseDate } from '@progress/kendo-angular-intl';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { Observable, Subscription } from 'rxjs';
import { GridFieldSummary } from '~/models/modules/gridField';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { ReportsService } from '~/services/modules/reports/reports';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FormatService } from '~/services/administration.ts/format';
import { TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { SharedService } from '~/services/sharedService';
import { ApproverDetailResponseModel } from '~/models/modules/approverDetailResponseModel';
import { StockPurchaseOrderResponseModel } from '~/models/modules/stockPurchaseOrderResponseModel';
import { POPreferencesService } from '~/services/administration.ts/po-preferences';
import { POPreference } from '~/models/administration/poPreference';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { NoteComponent } from '~/shared/components/note/note.component';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { fileSources } from '~/shared/enums/fileSources';
import { FileSelectedStream } from '~/models/modules/file';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';

import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { FilesService } from '~/services/modules/stocks/files';
import { stockPurchaseOrderFile } from '~/models/modules/stockPurchaseOrderFile';
import { EntityStatusOptions } from '~/models/entityStatus';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { GDataService } from '~/services/GDataService';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SiteShipToAddressService } from '~/services/modules/common/site-ship-to-address.service';
import { VendorSummary } from '~/models/modules/vendor';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { SysReceivesService } from '~/services/administration.ts/sysReceive';

@Component({
    selector: 'app-stock-purchase-orders-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockPurchaseOrdersUpsertComponent extends MultiSiteAwareComponent implements OnInit {
  _supplierFilterOption: string = 'all';
  _refreshStockGrid: boolean = false;
  selectedVendorId: number;
  _showVendorStockItemOnPOAndRece: boolean = false;
  //_showDocumentsGrid: boolean = false;
  _fileSource: fileSources;
  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _selectedAccounts: any[] = [];
  _uploaderSelectMessage: string = 'Upload file..';

  _storagePath: string;
  _costFormat: string;
  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _theme: string;
  _form: FormGroup;
  _active: boolean;
  _isNew: boolean;
  _invalidForm: boolean;
  _selectFile: boolean = false;
  _model: any;
  _file: File;
  _fileStream: any;
  _selectedAccount = new FormControl();

  _sortingSelected = new FormControl('old');
  _defaultQuantity = new FormControl();
  _defaultUnitCost = new FormControl();
  _quantity = new FormControl();
  _unitCost = new FormControl();
  _expirationDate = new FormControl();
  //_sites: any[];
  _note: string;
  //_sitesFiltered: any[];
  _addresses: any[];
  _addressesFiltered: any[];
  _vendors: any[];
  _vendorsFiltered: any[];
  _selectedStockItem = new FormControl();
  _poNumber = new FormControl();
  _items: any[];
  _itemsFiltered: any[];
  _inventoryGridData: PurchaseOrderDetail[] = [];

  _approvalCycleEnabled: boolean = false;
  _submitted: boolean = false;
  _isCreator: boolean = false;
  _isFirstApprover: boolean = false;
  _isSecondApprover: boolean = false;

  _firstApprovalEnabled: boolean = false;
  _firstApprovalStatus: string = 'pending';

  _secondApprovalEnabled: boolean = false;
  _secondApprovalStatus: string = 'pending';

  _approvalCycleState: string = 'pending';

  _showStocksGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _stockItemsGridColumns: GridFieldSummary[];
  _showVendorsGrid: boolean = false;
  _selectedVendors: any;
  _vendorsGridColumns: GridFieldSummary[];
  _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
  _showAddVendorWindow: boolean = false;

  _minDate: Date = new Date(1901, 1, 1);
  _windowState: WindowState = 'maximized';
  _subtotal: number = 0;
  _shipping: number = 0;
  _discount: number = 0;
  _otherAdjustment: number = 0;
  _tax: number = 0;
  _total: number = 0;
  _showSave: boolean = true;

  showReports: boolean = false;
  purchaseOrderReports: any;
  transactionId: number;


  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any;


  _page: string = 'purchaseOrders';
  _permissionScope = 'purchaseOrders';
  _index: number;
  _selectedLabelId: number;
  _selectedTabId: number;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isAddTabFormValue: boolean = false;
  _selectedAccountIds: any[] = [];
  _customTabs: any;
  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _language: string = 'en';
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  _deactivatedFieldsGridData: Array<any> = [];
  okCloseSubscription: any = null;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _customFieldsDictionary: { [key: string]: string } = {};
  _pageState: PageState;
  _isOs: boolean;
  _gridColumns: GridFieldSummary[];
  _datePickerFormat: string;

  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;

  stockItemVendorCost: number;
  poPreference: POPreference;

  _itemFilter: string;
  reactivate: boolean = false;
  reactivateItem: any;
  previousValue: string;

  // #region Videos/Documents/Pictures
  _filesPageName: string = 'files';
  _documentsPageName: string = 'documents'
  _videosPageName: string = 'videos'
  _imageSearchControl = new FormControl();
  _documentSearchControl = new FormControl();
  _videoSearchControl = new FormControl();
  _showImagesGrid: boolean = false;
  _showDocumentsGrid: boolean = false;
  _showVideoGrid: boolean = false;
  _imageSearchResult: string;
  _documentSearchResult: string;
  _videoSearchResult: string;
  _filesGridFields: GridFieldSummary[];
  _documentsGridFields: GridFieldSummary[];
  _videosGridFields: GridFieldSummary[];
  _filesGridFieldsSub!: Subscription;
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _selectedDocumentsKeys: number[] = [];
  _selectedVideos: any[] = [];
  _selectedVideosKeys: number[] = [];
  _purchaseOrderFilesPics: stockPurchaseOrderFile[] = [];
  _purchaseOrderFilesDoc: stockPurchaseOrderFile[] = [];
  _purchaseOrderFilesVideo: stockPurchaseOrderFile[] = [];
  _selectedObjectImages: any[] = [];
  _selectedObjectDocuments: any[] = [];
  _selectedObjectVideos: any[] = [];
  _selectedUpsertImagesKeys: number[] = [];
  // #endregion
  _reportOpened: boolean = false;


  @Input() model: PurchaseOrder;

  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_vendors') kendoComboVendors: ComboBoxComponent;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;
  @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('unitcost_input') unitCostInput: NumericTextBoxComponent;
  @ViewChild('po_input') poInput: ElementRef;
  @ViewChild('textarea_vendoraddress') vendorAddressTextarea: ElementRef;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;
  //@ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('kendo_uploader_wrapper') uploadWrapper: ElementRef;
  @ViewChild('kendo_uploader') upload: UploadComponent;

  isGeneralInformationExpanded: boolean = true;
  isScanInventoryExpanded: boolean = true;

  _gridColumnsDuplicate: GridFieldSummary[];
  stockPurchaseOrder: StockPurchaseOrderResponseModel;
  creator: ApproverDetailResponseModel;
  isEditMode: boolean = false;
  hasApprovalCycle: boolean = false;

  _isEditForms: boolean = false;

  quantityFormat: string;
  digitNumber: number;

  isOpened: boolean = false;
  timeOut: any;
  isLoading: boolean = false;
  beginScroll: boolean;
  clearTimeout: any;
  reloadlist: any;
  comboBoxpagingationParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1,
    pagenumber: 1
  };

  //#region New StockItem Combobox Fields
  _itemsNew: any[];
  _itemsFilteredNew: any[];
  _allStockItemsCount: number = 0;
  _stockItemComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1
  };
  _stockItemComboScroll: boolean = false;
  _stockItemDDSearch: string = null;
  //#endregion
  //#region Multi Site Variables

  //#endregion
  _showVendorFileNotes: boolean = false;
  _vendorNotesModel: VendorSummary;
  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;
  _showStockItemFileNotes: boolean = false;
  _stockItemNotesModel: StockItemSummary;
  //#region Custom Fields Fix
  _customValidation: any = [];
  _entity = 'Stock';
  _systemFields: GridFieldSummary[] = [];
  _editedSystemFields: any = [];
  copyModelId: number;
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  requiredSystemTabs: any = [];
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  _additionalErrors: any = [];
  //#endregion
  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _vendorsService: VendorsService,
    private _addressesService: AddressesService,
    private _purchaseOrdersService: PurchaseOrdersService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private windowService: WindowService,
    private _reportService: ReportsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _poPreferenceService: POPreferencesService,
    private quantityFormatsService: QuantityFormatsService,
    private _filesService: FilesService,
    private _dataService: GDataService,
    private _renderer2: Renderer2,
    private _multiSitesService: MultiSiteService,
    private _siteShipToAddress: SiteShipToAddressService,
    private _sysReceivesService: SysReceivesService,
  ) {
    super();
    this._getdata();
    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if ((str?.response || str?.picObject) && str.component == 'files') {
          this._addPicture(str);
        }
        if ((str?.response || str?.picObject) && str.component == 'documents') {
          this._addDocument(str);
        }
        if ((str?.response || str?.picObject) && str.component == 'videos') {
          this._addVideo(str);
        }
      }
      if (str?.isClosed) {
        this._isDialiog = false;
      }
    });


    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.okCloseClicked.subscribe((data) => {
      if (data) {
        setTimeout(() => {
          this.kendoComboItems.toggle();
          this.kendoComboItems.focus();
        });
      }
    });

    this.LoadData();


    this._poPreferenceService.getPOPreference()
      .pipe()
      .subscribe(res => {
        this.poPreference = res;
      });
    this._sysReceivesService.getSysReceive().subscribe((data) => {
      if (data != null) {
        this._showVendorStockItemOnPOAndRece = data.showVendorStockItemOnPOAndRece ?? false;
      }
    });
    this._vendorsService.vendorAdded.subscribe(x => {
      if (x.siteId == this._form.controls['site'].value?.id || !x.siteId) {
        const vendor = { code: x.code, id: x.id, name: x.name, entityAddress: x.entityAddress };
        this._vendors.push(vendor);
        this._vendorsFiltered = this._vendors;

        this._form.controls['vendor'].setValue(x);
        this._handleVendorsChange(x);
      }

    })
    this._vendorsService.vendorUpdated.subscribe(vendor => {
      var UpdatedRecord = this._vendors.find(x => x.id == vendor.id);
      if (UpdatedRecord) {
        var Index = this._vendors.indexOf(UpdatedRecord);
        this._vendors[Index] = vendor;
      }
      this._form.controls['vendor'].setValue(vendor);
      this._handleVendorsChange(vendor);
    })
    // this._vendorsService.vendorClosed.subscribe((data) => {
    //   this._showAddVendorWindow = false;
    //   if (data) {
    //     setTimeout(() => {
    //       var newlyAddedVendor = this._vendors.filter(
    //         (s) => s.code.toLowerCase() == data.toLowerCase()
    //       )[0];
    //       if (newlyAddedVendor != null) {
    //         this._form.patchValue({
    //           vendor: { id: newlyAddedVendor.id, code: data }
    //         });
    //       }
    //     }, 200);
    //   }
    // });

    this._layoutManager.applyOverly();

    this._layoutManager.formChanged.subscribe((x) => {
      if (x === 'vendors') {
        //this._loadVendorsDD();
      }

      if (x === 'addresses') {
        if (this._form.get('site').value) {
          //this._loadAddressesDD();
        }
      }
    });

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
      this._stockItemsGridColumns = gridColumns;
    }));

    this._gridFields
      .getGridFieldsByPage('vendors')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('vendors', (gridColumns) => {
      this._vendorsGridColumns = gridColumns;
    }));
    this._currentUser = this._securityService.currentUser;

    // this._vendorsService.vendorAdded.subscribe(x => {
    //   const vendor = { code: x.code, id: x.id, name: x.name, entityAddress: x.entityAddress,
    //     customerShipToAddresses: x.customerShipToAddresses};
    //   this._vendorsFiltered.push(vendor);
    //   this._form.controls['vendor'].setValue(vendor);
    //     this._handleVendorsChange(vendor);
    //   })
  }

  //#region Stock Item With Paging Dropdown
  getStockItemDDPaging(siteId?: number): void {
    if (!this._stockItemComboScroll) {
      this._stockItemsService.getstockItemListingWithPaging(siteId, this._stockItemComboBoxPagingParams)

        .subscribe((data: any) => {
          this._allStockItemsCount = data.body.returnCount;
          this._itemsNew = [...data.body.data];
          this._itemsFilteredNew = [...data.body.data];
        });
    }
    else {
      this._stockItemsService.getstockItemListingWithPaging(siteId, this._stockItemComboBoxPagingParams)

        .subscribe((data: any) => {
          this._itemsNew = this._itemsNew.concat(data.body.data);
          this._itemsFilteredNew = [...this._itemsNew];
        });
    }
  }
  _handleItemsFilterDropDownPaging(_filter: any) {
    this._stockItemDDSearch = _filter;
    this._stockItemComboScroll = false;
    setTimeout(() => {
      this._stockItemComboBoxPagingParams.search = _filter;
      this._stockItemComboBoxPagingParams.currentItem = '0';
      this._stockItemComboBoxPagingParams.page = 1;
      this.getStockItemDDPaging(this._form.controls['site'].value?.id);
    }, 1000);
  }
  scrollComboboxNew(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        let domobject = document.querySelector('.k-list-content');
        if (domobject) {
          this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
            if (this._itemsNew.length < this._allStockItemsCount) {
              if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                this._stockItemComboScroll = true;
                this._stockItemComboBoxPagingParams.currentItem = (parseInt(this._stockItemComboBoxPagingParams.currentItem) + this._stockItemComboBoxPagingParams.totalbyPage).toString();
                this._stockItemComboBoxPagingParams.page++;
                this.getStockItemDDPaging(this._form.controls['site'].value?.id);
              }
            }
          });
        }
      }
    }, 500);
  }
  //#endregion

  _saveAndPrint() {
    this._onSave(false, true, 'saveAndPrint');
  }

  ExpandCollapseScanInventoryWidget(isExpand: boolean) {
    this.isScanInventoryExpanded = !isExpand;
  }

  ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
    this.isGeneralInformationExpanded = !isExpand;
  }


  async LoadData() {
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._purchaseOrderFilesPics = [];
    this._purchaseOrderFilesDoc = [];
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    if (this._model?.stockPurchaseOrderFiles) {
      this._model.stockPurchaseOrderFiles.forEach((element: any) => {
        if (element.file?.type.includes('image')) {
          this._purchaseOrderFilesPics.push(element);
        }
        else if (element.file?.type.includes('video')) {
          this._purchaseOrderFilesVideo.push(element);
        }
        else {
          this._purchaseOrderFilesDoc.push(element);
        }
      });
    }
    if (this._model && this._pageState == PageState.ADD) {
      this.copyModelId = this._model.id; // for loading custom fields data if there is any
    }
    var loggedInAccountSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));

    if (loggedInAccountSites && loggedInAccountSites.length > 0) {
      this.siteId = loggedInAccountSites[0].siteId;
    }


    if (this._model && this._model.id && this._model.id > 0 && this._pageState != 5) {
      this.isEditMode = true;
      this.stockPurchaseOrder = this._model;

      if (this.stockPurchaseOrder && this.stockPurchaseOrder.approvers && this.stockPurchaseOrder.approvers.length > 0) {
        this.creator = this.stockPurchaseOrder.approvers.find(f => f.isCreator == true);
      }

    }



    this._active = true;

    if (this._model?.id)
      this._isNew = false;
    else
      this._isNew = true;


    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }

  }

  ngOnInit() {
    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';

    // if (this._model != null && this._model.site != null && this._model.site.id != null && this._model.site.account != null && this._model.site.account.id != null) {
    //   this._loadSitesAndInitDDDD(this._model.site.account.id, false);
    // }
    //this._loadVendorsDD();
    //this._loadAddressesDD();

    this._initForm();

    this._form.get('account').valueChanges.subscribe((x) => {
      if (x) {
        if (this._isNew || !this._submitted) {
          this._clearGridData();
          this._form.get('site').setValue(null);
          this._loadSitesAndInitDDDD(x.id);
        }
      }
    });

    this._form.get('site').valueChanges.subscribe((x) => {
      if (x) {
        //this._clearGridData();
        // this._loadItemsDD(x.id);
        this.getStockItemDDPaging(this._form.controls['site'].value?.id);
        //this._getStockItems();

        // setTimeout(() => {
        //   // this.kendoComboVendors.toggle(true);
        //   // this.kendoComboVendors.focus();
        // });
      }
    });

    this._form.get('vendor').valueChanges.subscribe((x) => {
      if (x) {
        setTimeout(() => {
          if (this.kendoComboAddresses) {
            this.kendoComboAddresses.toggle(true);
            this.kendoComboAddresses.focus();
          }

        });
      }
    });

    this._form.get('address').valueChanges.subscribe((x) => {
      if (x && (this._isNew || !this._submitted)) {
        setTimeout(() => {
          if (this.poInput)
            this.poInput.nativeElement.focus();
        });
      }
    });

    this._poNumber.valueChanges.subscribe((x) => {
      if (x) {
        this._form.patchValue({
          poNumber: x.toString()
        });
      }
    });

    this._selectedStockItem.valueChanges.subscribe((x) => {
      if (x) {
        let gridItem = this._inventoryGridData.find(r => r.itemNumber === x.number);
        if (!gridItem) {
          if (this._defaultQuantity.value) {
            setTimeout(() => {
              this.fillGrid();
            });
          }
        }
      } else {
        this._unitCost.setValue(null);
        if (!this._defaultQuantity.value) {
          this._quantity.setValue(null);
        }
      }
    });

    this._sortingSelected.valueChanges.subscribe((x) => {
      this._inventoryGridData.reverse();
    });

    this._OpenAccount();

    this.getFormTabs();
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getAuth();

    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
  }

  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {

        if (this.kendoComboVendors !== undefined) {
          this.kendoComboVendors.toggle(true);
          this.kendoComboVendors.focus();
        }
      });
    }
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  _onStatusChange(statusId: number) {

    let model: any = {};
    if (this._model.stockPurchaseOrderStatusId != null && this._model.stockPurchaseOrderStatusId == 4 && statusId == 4) {
      statusId = 6;
    }
    model.stockPurchaseOrderStatusId = statusId;
    this._purchaseOrdersService
      .updatePurchaseOrderStatus(this._model.id, model)

      .subscribe(() => {
        this._closeForm();
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  _handleAccountsChange(value: any) {
    this._clearGridData();
  }

  // _handleSitesChange(value: any) {
  //   this._clearGridData();
  // }



  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  enabledisablesavebutton() {
    if (!this.isEditMode || (!this.isEditMode && (!this.stockPurchaseOrder?.isSubmitted && !this.stockPurchaseOrder?.isApproved)) && this._pageState != 1) {
      return true
    }
    return false
  }


  _loadSitesAndInitDDDD(accountId: number, toggle: boolean = true) {
    return this._accountsService.getSitesListByAccount(accountId)
      .subscribe((data: any) => {
        this._sites = data.filter((x: { name: string }) => x.name != 'All Sites');
        this._sitesFiltered = this._sites;
        if (toggle) {
          setTimeout(() => {
            this.kendoComboSites.toggle();
            this.kendoComboSites.focus();
          });
        }
      });
  }

  _loadVendorsDD(siteId: number = null) {
    return this._vendorsService.getVendorsListing(null, siteId)
      .subscribe((data: any) => {
        this._vendors = data;
        this._vendorsFiltered = data;
        if (this._model?.vendor) {
          const matched = this._vendors?.find((x: any) => x.id === this._model.vendor.id);
          this._handleVendorsChange(matched || this._model.vendor);
        }
      });
  }

  _handleVendorsChange(value: any) {
    this.hasApprovalCycle = false;
    this.selectedVendorId = value?.id;
    if (this.vendorAddressTextarea?.nativeElement) {
      this.vendorAddressTextarea.nativeElement.value = this._fillAddressDetails(value);
    }

    if (value && value.id > 0) {
      const hasDetails = value.entityAddress?.addressLine1 || value.addressLine1 || value.entityAddress?.city || value.city;
      if (!hasDetails) {
        this._vendorsService.getVendor(value.id).subscribe((vendor: any) => {
          if (vendor) {
            value.entityAddress = vendor.entityAddress;
            if (this.vendorAddressTextarea?.nativeElement) {
              this.vendorAddressTextarea.nativeElement.value = this._fillAddressDetails(vendor);
            }
          }
        });
      }
    }

    if (this._inventoryGridData && this._inventoryGridData.length > 0) {
      this._inventoryGridData.forEach(item => {
        item.vendorStockNumber = this.getVendorStockNumber(item);
      });
    }

    setTimeout(() => {
      //this.kendoComboVendors.toggle(true);
    });
    if (this.isEditMode == false && this._form.controls['site'].value && value && value.id > 0) {
      this._vendorsService.CheckIfVendorHasApprovalCycle(value.id, this._form.controls['site'].value.id)
        .subscribe((result: any) => {
          this.hasApprovalCycle = result.hasApprovalCycle;
        });
    }
  }

  _fillAddressDetails(value: any) {
    var addressDetails = '';
    if (value != null) {
      value = (value.entityAddress == null) ? value : value.entityAddress;
      if (value.addressLine1 != null && value.addressLine1 != '') {
        addressDetails += value.addressLine1;
      }
      if (value.addressLine2 != null && value.addressLine2 != '') {
        addressDetails += '\n' + value.addressLine2;
      }
      if (value.city != null && value.city != '') {
        addressDetails += '\n' + value.city;
      }
      if (value.state != null && value.state != '') {
        if (value.city != null && value.city != '') {
          addressDetails += ' ' + value.state;
        } else {
          addressDetails += '\n' + value.state;
        }
      }
      if (value.zip != null && value.zip != '') {
        if (value.state != null && value.state != '') {
          addressDetails += ' ' + value.zip;
        } else {
          addressDetails += '\n' + value.zip;
        }
      }
      if (value.country != null && value.country != '') {
        addressDetails += '\n' + value.country;
      }
    }
    return addressDetails;
  }

  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadAddressesDD(siteId?: number) {
    // return this._addressesService.getAddressesSummary()
    //   .subscribe((data: any) => {
    //     data.unshift({ id: -1, name: '<No Address>' }); //add on top
    //     this._addresses = data;
    //     this._addressesFiltered = data;

    //   });
    return this._siteShipToAddress
      .getSiteShipToAddress(null, siteId)
      .subscribe((data: any) => {
        this._addresses = [];
        if (data && data.body) {
          data.body.forEach((element: any) => {
            this._addresses.push(element.address);
          });
        }

        this._addresses.unshift({ id: -1, name: '<No Address>' });
        this._addressesFiltered = this._addresses;
      });
  }

  _handleAddressesChange(value: any) {
    if (this.addressTextarea?.nativeElement) {
      this.addressTextarea.nativeElement.value = this._fillAddressDetails(value);
    }
    setTimeout(() => {
      this.kendoComboAddresses?.toggle(false);
    });
  }

  _handleAddressesFilter(value: any) {
    this._addressesFiltered = this._addresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  _loadItemsIniti(siteId: number) {
    this.previousValue = this.comboBoxpagingationParams.search;
    return this._stockItemsService.getStockItemsListingBySiteWithPoDetails(siteId, this.comboBoxpagingationParams)
      .subscribe((data: any) => {
        this._itemsFiltered = data.body;
        this._items = data.body;
      });
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
  filterarray: any[] = [];

  _loadItemsDD(siteId: number) {
    if (!this.beginScroll) {
      this.comboBoxpagingationParams = {
        currentItem: '0',
        totalbyPage: 20,
        search: this.comboBoxpagingationParams.search != '' ? this.comboBoxpagingationParams.search : '',
        page: 1,
        pagenumber: 1
      };
      return this._stockItemsService.getStockItemsListingBySiteWithPoDetails(siteId, this.comboBoxpagingationParams)
        .subscribe((data: any) => {
          this._itemsFiltered = data.body;
          this._items = data.body;
        });

    } else {
      if (this.comboBoxpagingationParams.page == 1) this.comboBoxpagingationParams.page = 2;
      return this._stockItemsService.getStockItemsListingBySiteWithPoDetails(siteId, this.comboBoxpagingationParams)
        .subscribe((data: any) => {
          if (data.body.length) {
            if (this._itemsFiltered.length) {
              data.body.forEach((a: any) => {
                let resualt = this._itemsFiltered.find((d: any) => d.number === a.number);
                if (resualt === undefined) {
                  this.filterarray.push(data.body.find((d: any) => d.number === a.number));
                }

              });
              this._itemsFiltered = [...this._itemsFiltered, ...this.filterarray];
              this._items = [...this._itemsFiltered, ...this.filterarray];
              this.filterarray = [];

              if (this.comboBoxpagingationParams != null)
                this.comboBoxpagingationParams.page += 1;

            }
          }
        });
    }



  }

  _handleItemsFilter(value: any) {
    if (this.timeOut) clearTimeout(this.timeOut);
    var doneTypingInterval = 10;  //time in ms, 5 seconds for example
    this._itemFilter = value;
    this.timeOut = setTimeout(() => {
      this.comboBoxpagingationParams.search = this._itemFilter;
      this.comboBoxpagingationParams.currentItem = '0';
      this.comboBoxpagingationParams.pagenumber += 1;

      this._itemsFiltered = this._items.filter((x: any) => x.number.toLowerCase().includes(value.toLowerCase()));


      if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
        //this._loadItemsDD(this._model.site.id);
      }
      else {
        var siteId = this._form.get('site').value;
        //this._loadItemsDD(siteId.id);
      };
    }, doneTypingInterval);


  }

  _handleItemsChange(value: any) {

    if (value != null) {
      setTimeout(() => {
        this.quantityInput.focus();
      });

      this.stockItemVendorCost = undefined;

      if (value.stockItemVendors && value.stockItemVendors.length > 0) {
        for (var i = 0; i < value.stockItemVendors.length; i++) {
          if (value.stockItemVendors[i].vendorId == this.selectedVendorId) {
            this.stockItemVendorCost = value.stockItemVendors[i].price;
          }
        }
      }

      if (this.stockItemVendorCost != null && this.stockItemVendorCost > 0) {
        this._unitCost.setValue(this.stockItemVendorCost);
      }
      else if (value.costInfo != null && value.costInfo.cost != null) {
        this._unitCost.setValue(value.costInfo.cost);
      }
    }
  }

  _quantitySubmited() {
    if ((this._defaultUnitCost.value == null || this._defaultUnitCost.value == false) && this.unitCostInput.value == null) {
      this.unitCostInput.focus();
      return;
    }
    if (this._selectedStockItem.value) {
      this.fillGrid();
    } else {
      setTimeout(() => {
        this.kendoComboItems.toggle();
        //this.kendoComboItems.focus();
      });
    }
  }


  getVendorStockNumber(item: any): string {
    if (!item) return '';
    const vendorId = this.selectedVendorId ?? this._form?.get('vendor')?.value?.id ?? this._model?.vendor?.id ?? this._selectedVendors?.[0]?.id;
    const vendors = item.stockItemVendors || item.stockItem?.stockItemVendors;
    if (vendors && vendors.length > 0) {
      if (vendorId && vendorId > 0) {
        const match = vendors.find((v: any) => v.vendorId === vendorId);
        if (match && (match.stockNumber || match.code)) return match.stockNumber || match.code;
      }
      const preferred = vendors.find((v: any) => v.isPreferred);
      if (preferred && (preferred.stockNumber || preferred.code)) return preferred.stockNumber || preferred.code;
      if (vendors[0]?.stockNumber || vendors[0]?.code) return vendors[0].stockNumber || vendors[0].code;
    }
    return item.vendorStockNumber || '';
  }

  _removeHandler({ sender, dataItem }: any) {
    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != dataItem.itemNumber);
    this._updateGridFooterValues();
  }

  _onOrderQuantityChange(e: any, item: PurchaseOrderDetail) {
    item.unitsOrdered = e;
    item.extendedCost = e * item.unitCost;

    item.backorderQty = item.unitsOrdered - item.receivedQty;
    this._updateGridFooterValues();
  }

  _onUnitCostChange(e: any, item: PurchaseOrderDetail) {
    item.unitCost = e;
    item.extendedCost = e * item.unitsOrdered;

    this._updateGridFooterValues();
  }

  _onUnitsReceivedChange(e: any, item: PurchaseOrderDetail) {
    item.receivedQty = e;
    item.backorderQty = item.unitsOrdered - e;

    this._updateGridFooterValues();
  }

  _onShippingChange(e: any) {
    this._shipping = e;
    this._updateGridFooterValues();
  }

  _onDiscountChange(e: any) {
    this._discount = e;
    this._updateGridFooterValues();
  }

  _onOtherAdjustmentChange(e: any) {
    this._otherAdjustment = e;
    this._updateGridFooterValues();
  }

  _onTaxChange(e: any) {
    this._tax = e;
    this._updateGridFooterValues();
  }

  _updateGridFooterValues() {
    this._subtotal = this._inventoryGridData.reduce((sum, current) => sum + current.extendedCost, 0);
    this._total = this._subtotal + this._shipping - this._discount - this._otherAdjustment + this._tax;
  }
  //#region  _openForm
  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', fileSource: fileSources.purchaseOrder };
  }

  _closeDialog(event: any) {
    if (typeof event === 'boolean') {
      this._isDialiog = event;
    } else {
      this._isDialiog = event?.open ?? false;
    }
  }


  //#endregion
  _selectStocksHandler(): void {
    this._supplierFilterOption = 'all';
    this._showStocksGrid = true;
  }

  _onSupplierFilterChange(): void {
    this._refreshStockGrid = !this._refreshStockGrid;
  }

  _returnSelectedStocksHandler(e: any[]): void {
    this._showStocksGrid = false;
    this._selectedStocks.forEach((item: StockItemSummary) => {
      let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
      if (!gridItem) {

        this._inventoryGridData.push({
          stockItemId: item.id,
          unitsReceived: 0,
          stockPurchaseOrderId: 0,
          id: 0,
          backorderQty: 0,
          receivedQty: 0,
          itemNumber: item.number,
          description: item.description,
          unitsOrdered: this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0,
          uom: item.receiveUnitOfMeasure.code,
          unitCost: this._defaultUnitCost.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitCost.value ?? 0),
          extendedCost: (this._defaultUnitCost.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitCost.value ?? 0)) * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0),
          isTaxable: (item.costInfo != null && item.costInfo.isTaxable != null) ? item.costInfo.isTaxable : false,
          stockItemVendors: item.stockItemVendors,
          vendorStockNumber: this.getVendorStockNumber({ stockItemVendors: item.stockItemVendors })
        });
      }
    });
  }

  _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    model = model || {};
    const vendorVal = this._form?.controls['vendor']?.value;
    let selectedVendorId = vendorVal?.id ?? (typeof vendorVal === 'number' ? vendorVal : null);
    if (!selectedVendorId && (this as any).selectedVendorId) {
      selectedVendorId = (this as any).selectedVendorId;
    }
    if (!selectedVendorId && this._model?.vendor) {
      selectedVendorId = this._model.vendor.id ?? (typeof this._model.vendor === 'number' ? this._model.vendor : null);
    }

    if (this._supplierFilterOption === 'perSupplier') {
      if (selectedVendorId) {
        model.supplierFilterValue = 2;
        model.supplierId = selectedVendorId;
      }
    } else if (this._supplierFilterOption === 'perPreferredSupplier') {
      if (selectedVendorId) {
        model.supplierFilterValue = 3;
        model.supplierId = selectedVendorId;
      }
    } else {
      model.supplierFilterValue = 1;
    }

    return this._stockItemsService.getStockItems(params, model, this._form.controls['site'].value?.id);
  }

  _closeStocksWindow(): void {
    this._showStocksGrid = false;
  }

  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    e.forEach((item) => {
      this._selectedStocks.push(item);
    });
  }

  _selectVendorsHandler(): void {
    this._showVendorsGrid = true;
  }

  _returnSelectedVendorHandler(e: any[]): void {
    this._showVendorsGrid = false;
    this._form.patchValue({
      vendor: this._selectedVendors[0]
    });

    if (this._selectedVendors[0] !== undefined && this._selectedVendors[0] !== null) {
      this.selectedVendorId = this._selectedVendors[0].id;
      this.vendorAddressTextarea.nativeElement.value = this._fillAddressDetails(this._selectedVendors[0]);
      if (this._inventoryGridData && this._inventoryGridData.length > 0) {
        this._inventoryGridData.forEach(item => {
          item.vendorStockNumber = this.getVendorStockNumber(item);
        });
      }
      setTimeout(() => {
      });
      if (this.isEditMode == false && this.siteId > 0 && this._selectedVendors[0] && this._selectedVendors[0].id > 0) {
        this._vendorsService.CheckIfVendorHasApprovalCycle(this._selectedVendors[0].id, this.siteId)

          .subscribe((result: any) => {
            this.hasApprovalCycle = result.hasApprovalCycle;
          });
      }
    }

  }

  _getVendors = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._vendorsService.getVendors(params, model, this._form.controls['site'].value?.id);
  }

  _closeVendorsWindow(): void {
    this._showVendorsGrid = false;

    this._gridFields
      .getGridFieldsByPage('vendors')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('vendors', (gridColumns) => {
      this._vendorsGridColumns = gridColumns;
    }));
    this._currentUser = this._securityService.currentUser;


  }



  _onVendorRowSelectionChanges(e: any[]) {
    this._selectedVendors = [];
    e.forEach((item) => {
      this._selectedVendors.push(item);
    });
  }

  // _openAddVendor() {
  //     this._showAddVendorWindow = true;
  //     setTimeout(() => {
  //         const windowRef = this.windowService.open({
  //             title: 'Add New Vendor',
  //             content: StocksVendorsUpsertComponent,
  //             width: 956
  //         });
  //     });
  // }

  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._poNumber.setValue(data.result.toString());
        this._form.patchValue({
          poNumber: data.result.toString()
        });
        setTimeout(() => {
          this.kendoComboItems.toggle();
          this.kendoComboItems.focus();
        });
      });
  }

  private checkInventoriesValiation(): boolean {
    // for (let item of this._inventoryGridData) {
    //     if (item.itemType === 'standard') {
    //         if (item.quantity <= 0) {
    //             return false;
    //         }
    //     }

    //     if (item.itemType === 'non-inventory') {
    //         if (item.quantity <= 0 || !item.inventoryCode) {
    //             return false;
    //         }
    //     }

    //     if (item.itemType !== 'non-inventory' && item.itemType !== 'standard') {
    //         if (item.quantity <= 0 || !item.inventoryCode || !item.expirationDate) {
    //             return false;
    //         }
    //     }
    // }

    return true;
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('purchaseOrders', quantity);
  }

  private _initForm() {
    this._form = this._fb.group({
      vendor: [this._model.vendor ?? null, Validators.required],
      address: [this._model.address ?? null],
      account: [(this._model.site && this._model.site.account) ?? null, Validators.required],
      site: [this._model.site ?? null, Validators.required],
      isClosed: [this._model.isClosed ? this._model.isClosed.toString() : 'false'],
      orderDate: [this._model.orderDate ? parseDate(this._model.orderDate) : new Date(), Validators.required],
      poNumber: [this._model.poNumber ?? null, Validators.required],
      dueDate: [this._model.dueDate ? parseDate(this._model.dueDate) : null],
      expectedDeliveryDate: [this._model.expectedDeliveryDate ? parseDate(this._model.expectedDeliveryDate) : null]
    });

    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
      if (loggedInAccountSites != '') {
        this._form.patchValue({
          account: { id: JSON.parse(loggedInAccountSites)[0].accountId, name: '' },
          //site: { id: JSON.parse(loggedInAccountSites)[0].siteId, name: '' }
        });
        //this.getStockItemDDPaging();
        //this._loadItemsDD(JSON.parse(loggedInAccountSites)[0].siteId);
      }
    }

    if (this._model != null && this._model.id != null) {
      this.transactionId = parseInt(this._model.id);
    }

    if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
      //this._loadItemsDD(this._model.site.id);
      //this.getStockItemDDPaging();
    }

    if (this._model.stockPurchaseOrderApproval != null) {
      this._approvalCycleEnabled = this._model.stockPurchaseOrderApproval.enableCycle;
      this._submitted = (this._model.stockPurchaseOrderStatusId != null && this._model.stockPurchaseOrderStatusId == 1
        || this._model.stockPurchaseOrderStatusId == 6) ? false : true;
      // this._isFirstApprover = this._model.stockPurchaseOrderApproval.approval1PersonId == this._model.currentPersonId ? true : false;
      // this._isSecondApprover = this._model.stockPurchaseOrderApproval.approval2PersonId == this._model.currentPersonId ? true : false;
      this._isCreator = this._model.approvers && this._model.approvers.length > 0 ? this._model.approvers[0].userId == this._currentUser.person.id ? true : false : false;
      if (this._model.approvers && this._model.approvers.length > 1 && this._model.approvers[1].isAdmin == false)
        this._isFirstApprover = this._model.approvers[1].userId == this._currentUser.person.id ? true : false;
      if (this._model.approvers && this._model.approvers.length > 2 && this._model.approvers[2].isAdmin == false)
        this._isSecondApprover = this._model.approvers[2].userId == this._currentUser.person.id ? true : false;

      if (this._model.approvers && this._model.approvers.length > 1 && this._model.approvers[1].isAdmin == true)
        this._isFirstApprover = this._currentUser.appRole.name == "Admin" ? true : false;
      if (this._model.approvers && this._model.approvers.length > 2 && this._model.approvers[2].isAdmin == true)
        this._isSecondApprover = this._currentUser.appRole.name == "Admin" ? true : false;;

      this._firstApprovalEnabled = this._model.stockPurchaseOrderApproval.enableApproval1;
      this._firstApprovalStatus = (this._model.stockPurchaseOrderStatusId != null && (this._model.stockPurchaseOrderStatusId == 4 || this._model.stockPurchaseOrderStatusId == 6)) ? 'completed' : 'pending';

      this._secondApprovalEnabled = this._model.stockPurchaseOrderApproval.enableApproval2;
      this._secondApprovalStatus = (this._model.stockPurchaseOrderStatusId != null && this._model.stockPurchaseOrderStatusId == 6) ? 'completed' : 'pending';

      if (this._model.stockPurchaseOrderStatusId != null) {
        if (this._model.stockPurchaseOrderStatusId == 2) {
          this._approvalCycleState = 'closed';
        } else if (this._model.stockPurchaseOrderStatusId == 5) {
          this._approvalCycleState = 'rejected';
        } else if (this._model.stockPurchaseOrderStatusId == 6) {
          this._approvalCycleState = 'completed';
        } else {
          this._approvalCycleState = 'pending';
        }
      }
    }

    setTimeout(() => {
      if (this._model != null && this._model.vendor != null) {
        this._handleVendorsChange(this._model.vendor);
      }
      if (this._model != null && this._model.address != null) {
        this._handleAddressesChange(this._model.address);
      } else {
        if (!this._isNew) {
          this._form.patchValue({
            address: { id: -1, name: '<No Address>' }
          });

          if (this._isNew || !this._submitted) {
            // setTimeout(() => {
            //     this.kendoComboAccounts.toggle();
            //     this.kendoComboAccounts.focus();
            // });
          }
        }
      }
    }, 500);

    this._defaultUnitCost.setValue(true);

    this._subtotal = this._model.subtotal ?? 0;
    this._shipping = this._model.shipping ?? 0;
    this._discount = this._model.discount ?? 0;
    this._otherAdjustment = this._model.otherAdjustment ?? 0;
    this._tax = this._model.tax ?? 0;
    this._total = this._model.total ?? 0;

    if (this._model != null && this._model.poNumber != null) {
      this._poNumber.setValue(this._model.poNumber);
    }
    if (this._model != null && this._model.stockPurchaseOrderDetails != null) {
      this._model.stockPurchaseOrderDetails.forEach((item: PurchaseOrderDetail) => {
        this._stockItemsService.getStockItem(item.stockItemId)

          .subscribe((data) => {

            this._inventoryGridData.push({
              stockItemId: item.stockItemId,
              unitsReceived: 0,
              backorderQty: item.unitsOrdered > 0
                && this._pageState != 5 ? (item.unitsOrdered - item.unitsReceived) : 0,
              receivedQty: this._pageState == 5 ? 0 : item.unitsReceived,
              id: 0,
              stockPurchaseOrderId: item.stockPurchaseOrderId,
              itemNumber: data.number,
              description: data.description,
              unitsOrdered: item.unitsOrdered,
              uom: data.receiveUnitOfMeasure.code,
              unitCost: item.unitCost,
              extendedCost: item.extendedCost,
              isTaxable: item.isTaxable,
              stockItemVendors: data.stockItemVendors,
              vendorStockNumber: this.getVendorStockNumber({ stockItemVendors: data.stockItemVendors })
            });
          });
      });
    }
  }



  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  private fillGrid() {
    let itemId = 0;
    let item = this._selectedStockItem.value;
    if (item.isAlternate) {
      itemId = item.parentStockItemId;
    }
    else {
      itemId = item.id;
    }
    let gridItem = this._inventoryGridData.find(x => x.itemNumber === item.number);
    this._stockItemsService.getStockItem(itemId)

      .subscribe((data) => {
        if (gridItem) {
          this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != gridItem.itemNumber);
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Duplicate item is found. The old entry has been removed.',
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
        }

        this._inventoryGridData.push({
          stockItemId: data.id,
          id: 0,
          stockPurchaseOrderId: 0,
          receivedQty: 0,
          backorderQty: this._quantity.value ? +this._quantity.value : 1,
          unitsReceived: 0,
          itemNumber: data.number,
          description: data.description,
          unitsOrdered: this._quantity.value ? +this._quantity.value : 0,
          uom: data.receiveUnitOfMeasure.code,
          unitCost: this._unitCost.value ?? 0,
          extendedCost: (this._unitCost.value ?? 0) * (this._quantity.value ? +this._quantity.value : 1),
          isTaxable: data.costInfo?.isTaxable,
          stockItemVendors: data.stockItemVendors,
          vendorStockNumber: this.getVendorStockNumber({ stockItemVendors: data.stockItemVendors })
        });

        // this.sortByDate(this._sortingSelected.value);
        this._selectedStockItem.setValue(null);

        setTimeout(() => {
          this.kendoComboItems.toggle();
          this.kendoComboItems.focus();
        });

        this._updateGridFooterValues();
      });
  }



  ApproveRejectPurchaseOrder(approve: boolean) {
    var body: any = {
      isApproved: approve,
      IsRejected: !approve
    };
    this._purchaseOrdersService
      .ApproveRejectSalesOrder(this.stockPurchaseOrder.id, body)

      .subscribe(() => {
        this._closeForm();
      });

  }

  OnSubmit(e: any, elementname: any) {
    this._onSave(true, false, elementname);
  }

  async _onSave(isSubmit: boolean = false, saveOnly: boolean = false, e: any) {
    this._addPurchaseOrder(isSubmit, saveOnly, e);

  }

  async _saveTransactionFiles(isSubmit: boolean = false, saveOnly: boolean = false, e: any) {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];
    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.purchaseOrder;
        _filesModel.push(model);
      });

      await this._filesService
        .createFileRange(_filesModel)

        .toPromise()
        .then((response: number[]) => {
          if (response != null) {
            existingFiles.forEach((v) => {
              let ext = response.find(r => r == v.existingFileId);
              if (ext == undefined) {
                response.push(v.existingFileId);
              }
            });
            this._addPurchaseOrder(isSubmit, saveOnly, e, response);
          }
        });
    }
  }
  _addPurchaseOrder(isSubmit: boolean = false, saveOnly: boolean = false, e: any, fileIds?: number[]) {
    if (this.selectedVendorId == undefined || this.selectedVendorId == null)
      this.selectedVendorId = this._form.value?.vendor?.id

    if (!this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add items to create the Purchase Order.',
        withoutConfirm: true
      });
    } else if (!this.checkInventoriesValiation()) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });
    }
    else if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    // else if (this._form.invalid && this._custominvalidForm) {
    //   this._invalidForm = true;
    // } else if (this._form.invalid) {
    //   this._invalidForm = true;
    // } else if (this._custominvalidForm) {
    //   this._invalidSubmit = true ;
    // }

    else if (this.selectedVendorId
      && this.selectedVendorId > 0) {

      var popupError: boolean = false;
      var stockItemCode: string;

      if (this.poPreference
        && this.poPreference.alertWhenNoSupplierEnabled) {
        this._inventoryGridData.forEach(element => {
          var costInfo = element.unitCost;
          if (element.stockItemVendors && element.stockItemVendors.length > 0) {
            element.stockItemVendors.forEach(vendor => {
              if (vendor.vendorId == this.selectedVendorId
                && vendor.price != costInfo) {
                popupError = true;
                stockItemCode = element.itemNumber;
              }
            });
          }
        });
      }

      this._invalidForm = false;
      const formModel = this._form.value;
      let model: any = {};
      if (this._pageState == PageState.COPY)
        this._model.id = null;

      if (this._model != null && this._model.id != null && this._pageState != PageState.COPY) {
        model['id'] = this._model.id;
      }

      // work with custom fields
      // if (this._customFieldsValue) {
      //   const entries = Object.entries(this._customFieldsValue);
      //   for (const [index, [key, value]] of entries.entries()) {
      //     this._customFieldsDictionary[key] = `${value}`;
      //   }
      // }
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      if (this.stockPurchaseOrder && this.stockPurchaseOrder.id && this.stockPurchaseOrder.id > 0) {
        model['id'] = this.stockPurchaseOrder.id;
      }
      model['customFieldsValue'] = this._customFieldsDictionary;
      if (formModel.isClosed == 'true')
        formModel.isClosed = true
      else
        formModel.isClosed = false

      model['isClosed'] = formModel.isClosed == null ? false : formModel.isClosed;
      model['poNumber'] = formModel.poNumber;
      model['orderDate'] = formModel.orderDate;
      model['dueDate'] = formModel.dueDate;
      model['expectedDeliveryDate'] = formModel.expectedDeliveryDate;
      //model['siteId'] = formModel.site.id;
      if (model['isClosed'] == 'true') {
        model['stockPurchaseOrderStatusId'] = 2;
      } else {
        model['stockPurchaseOrderStatusId'] = (this._model.stockPurchaseOrderStatus == null) ? 1 : this._model.stockPurchaseOrderStatus.id;
      }
      model['vendorId'] = (formModel.vendor == null) ? null : formModel.vendor.id;
      model['addressId'] = (formModel.address == null) ? null : ((formModel.address.id == -1) ? null : formModel.address.id);
      model['siteId'] = (formModel.site == null) ? null : formModel.site.id;
      //model['siteId'] = this._siteSelected?.id;
      model['items'] = this._inventoryGridData.map((x) => {
        return {
          stockItemId: x.stockItemId,
          unitsOrdered: Number(x.unitsOrdered)?.toFixed(this.digitNumber),
          unitCost: x.unitCost,
          extendedCost: x.extendedCost,
          isTaxable: x.isTaxable,
          UnitsReceived: x.receivedQty

        };
      });
      model['subtotal'] = this._subtotal;
      model['shipping'] = this._shipping;
      model['discount'] = this._discount;
      model['otherAdjustment'] = this._otherAdjustment;
      model['tax'] = this._tax;
      model['total'] = this._total;
      model['note'] = this._note;

      let _transactionFiles: stockPurchaseOrderFile[] = [];
      _transactionFiles.push(...this._purchaseOrderFilesPics);
      _transactionFiles.push(...this._purchaseOrderFilesDoc);
      _transactionFiles.push(...this._purchaseOrderFilesVideo);
      if (model['stockPurchaseOrderFiles'] == undefined) {
        model['stockPurchaseOrderFiles'] = [];
      }
      _transactionFiles.forEach((v) => {
        let item: any = {};
        item.fileid = v.fileId;
        item.stockPurchaseOrderId = v.stockPurchaseOrderId
        model['stockPurchaseOrderFiles'].push(item);
      })

      if (isSubmit == true) {
        model['isSubmit'] = isSubmit;
        this._purchaseOrdersService
          .SubmitSalesOrder(model)
          //
          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response.message,
              withoutConfirm: true
            });

            if (response.stopActionWarningCode == -1) return;

            if (e === 'saveAndClose') {
              this._closeForm(model);
            }
            else if (e === 'saveAndCopy') {
              this._form.controls.poNumber.setValue(null);
            }
            else if (e === 'saveAndNew') {
              this.openUpsert(this._page, {}, PageState.ADD);
            }

            if (e === 'submit') {
              this._closeForm(model);
            }
          });
      }
      else {
        if (this._model.id) {
          this._purchaseOrdersService
            .updatePurchaseOrder(this._model.id, model)

            .subscribe((response: any) => {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: !popupError ? 'Purchase Order updated successfully.' :
                  'Purchase Order created successfully. Unit Cost for ' + stockItemCode
                  + ' is not the same as Vendor Cost.',
                withoutConfirm: true
              });
              if (e === 'saveAndClose') {
                this._closeForm(model);
              }
              else if (e === 'saveAndCopy') {
                this._pageState = PageState.ADD;
                this._form.controls.poNumber.setValue(null);
                this._form.controls.orderDate.setValue(new Date());
                this._model.id = null;
                //this._model.orderDate=null;

              }
              else if (e === 'saveAndNew') {
                this.openUpsert(this._page, {}, PageState.ADD);
              }
              else if (e === 'saveAndPrint') {
                this._showPrintWindow();
              }


            });
        } else {

          this._purchaseOrdersService
            .createPurchaseOrder(model)

            .subscribe((responseId: any) => {
              this.note.createNote(parseInt(responseId));
              model.id = responseId;
              this.transactionId = responseId;
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: !popupError ? 'Purchase Order created successfully.' :
                  'Purchase Order created successfully. Unit Cost for ' + stockItemCode
                  + ' is not the same as Vendor Cost.',
                withoutConfirm: true
              });

              if (e === 'saveAndClose') {
                this._closeForm(model);
              }
              else if (e === 'saveAndCopy') {
                this._form.controls.poNumber.setValue(null);
              }
              else if (e === 'saveAndNew') {
                this.openUpsert(this._page, {}, PageState.ADD);
              }
              else if (e === 'saveAndPrint') {
                this._pageState = PageState.EDIT;
                this._model.id = responseId;
                this._showPrintWindow();
              }
              else {
                this._note = undefined;
                this._pageState = PageState.EDIT;
                this._model.id = responseId;

              }
            });
        }

      }
    }
  }
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this._initForm();
  }

  _onClear() {
    this._selectedDocumentsKeys = [];
    this._uploadedStream = [];
    this._selectedExistingFiles = [];
    this._uploaderSelectMessage = 'Upload file..';
    this.transactionId = null;
    this._form.setValue({
      site: null,
      orderDate: new Date(),
      dueDate: null,
      expectedDeliveryDate: null,
      isClosed: false,
      poNumber: null,
      vendor: null,
      address: null
    });
    this._selectedAccount.setValue(null);
    this._selectedStockItem.setValue(null);
    this._poNumber.setValue(null);
    this._defaultQuantity.setValue(null);
    this._defaultUnitCost.setValue(true);
    this.addressTextarea.nativeElement.value = '';
    this.vendorAddressTextarea.nativeElement.value = '';
    this._clearGridData();
  }

  _clearGridData() {
    this._subtotal = 0;
    this._shipping = 0;
    this._discount = 0;
    this._otherAdjustment = 0;
    this._tax = 0;
    this._total = 0;
    this._inventoryGridData = [];
  }


  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: 'purchaseOrders',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('purchaseOrders');
    this._layoutManager.setFromChanged('purchaseOrders');
    this.ngOnDestroy();
    this._purchaseOrdersService.purchaseOrdersFormClosed(this._form.get('poNumber').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};

  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _showPrintWindow() {
    if (this._form.controls['site'].value) {
      this._reportService.ReportsByCategoryName('purchaseOrders', false, this._form.controls['site'].value.id).subscribe(
        (x: any) => {
          this.purchaseOrderReports = x;
          this.showReports = true;
        });
    }
    else if (this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Select Site Code',
        withoutConfirm: true
      });
    }
  }

  _printReceiptReport() {

    var reportId = this.selectReceiptReport.value.id;
    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.EDIT, { reportId: reportId, transactionId: this.transactionId });
    this.showReports = false;
    this._reportOpened = true;
    this._sharedService.closeDialog.subscribe((x: any) => {
      x
      this._reportOpened = false;

    });
    // this._onClear();
  }

  // private sortByDate(sorting: string): void {
  //     if (sorting === 'desc') {
  //         this._inventoryGridData.sort((a: ReceiveTransaction, b: ReceiveTransaction) => {
  //             return a.expirationDate > b.expirationDate ? -1 : 1;
  //         });
  //     } else {
  //         this._inventoryGridData.sort((a: ReceiveTransaction, b: ReceiveTransaction) => {
  //             return a.expirationDate > b.expirationDate ? 1 : -1;
  //         });
  //     }
  // }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    // let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    // mobiletabstrip.classList.toggle('visibletab');
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  // _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
  //   Object.keys(customFieldsValue).forEach(key => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1 ,customFieldId:-1 });
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;
  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });

  }


  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  _onEditFields() {

    if (!this._currentUser.isEnterprise) {
      // if (!this._selectedAccounts.length) {

      //   this._layoutComponent.openPopup({
      //     title: 'Validation',
      //     message: 'Please choose the account with the site desired',
      //     withoutConfirm: true
      //   });
      // }
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {

      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._editFormActive = true;
        this._isCustomfieldsFormValue = true;

      }
    }

  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == 'stockItems' ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
          this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
          //go to zero based tab
          this.screenTabStrip.selectTab(0);
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first

              this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });

          if (response['close'] != null) {
            if (response['close'] == true) {
            } else {
              return;
            }
          }
        }
      });

  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _onCancel() {
    this._closeForm();
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  _closePrintForm() {
    this.showReports = false;
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels(true);
    this.getFormTabs();
    this.getAuth();
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: GridFieldSummary[]) => {
        this._systemFields = [...x];
        this._editedSystemFields = [...x];
        /* this._systemFields.forEach((s:GridFieldSummary, indx: number) =>{
          this._tabDisabledIndexes.push(indx);
        }) */
        this.loadCustomFields(this._model?.id?.toString());
      })
  }
  private loadCustomFields(entityId?: string) {
    //this._pacer.start();
    this._customFieldsService
      .getCustomFields(this._entity, this._page)

      .subscribe((data) => {
        data = data.filter(x => x.formTab?.page == this._page);
        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }

        this.setMandatoryFields();
      });
    //this._pacer.start()
    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );
      });
  }
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        if (element.customFieldsData != undefined) {
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }

  private loadLabels(isClosed: boolean = false) {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        if (isClosed) {
          this._initForm();
        }
      });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getLabel(objectCode: any, tabid: any = null) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this.getSystemFieldsAndCustomFields();
                  //this.loadCustomFields(this._model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                  var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);
                  if (deletedTab == undefined) {
                    this.getFormTabs();
                  }
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    // this.loadCustomFields(this._model?.id?.toString());
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _onEditForms() {
    this._isEditForms = true;
  }


  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  _fileRemoveEventHandler(e: any) {
    let fileName = e.files[0].name;
    let delFile: FileSelectedStream = this._uploadedStream.find(f => f.name.toLowerCase() == fileName.toLowerCase());
    if (delFile != undefined) {
      let indx = this._uploadedStream.indexOf(delFile);
      this._uploadedStream.splice(indx, 1);

    }
    this._fileStream = null;
  }
  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._fileStream = reader.result;
          if (this.checkFileExtention()) {
            let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
              stream: reader.result,
              size: file.rawFile.size,
              type: file.rawFile.type,
              name: file.rawFile.name,
              fileSource: fileSources.purchaseOrder,
              isNew: true
            });
            this._uploadedStream.push(_selectedFileModel);

          }
        };
      }
    });
    this._selectFile = this._fileSelectedChanges.length > 0;

    //this.checkFileExtention();
  }

  private checkFileExtention(): boolean {
    let fileUploadedName = this._file.name;
    const allowedExtensions = ['doc', 'docx', 'csv', 'xls', 'xlsx', 'pdf'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1];
    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only DOC, DOCX, XLS, XLSX, PDF and CSV extensions are allowed.',
        withoutConfirm: true
      });

      setTimeout(() => {
        this.upload.clearFiles();
        this._file = null;
        this._fileStream = null;
      });

      return false;
    } else {
      return true;
    }
  }



  //  scrollCombobox(event:any){
  //    this.isOpened = true;
  //     if (this.clearTimeout) clearTimeout(this.clearTimeout);
  //    this.clearTimeout = setTimeout(() => {
  //     if (this.isOpened) {
  //     this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e:any) => {
  //     if (e.target.offsetHeight + parseInt( e.target.scrollTop ) >= e.target.scrollHeight - 5) {
  //     this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
  //      this.beginScroll = true;
  //        var siteId =  this._form.get('site').value;
  //       this._loadItemsDD(siteId.id);
  //     }
  //   });
  //         }
  //     }, 10);
  // }

  scrollCombobox(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
            this.beginScroll = true;
            this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
            var siteId = this._form.get('site').value;
            //this._loadItemsDD(siteId.id);
          }
        });
      }
    }, 0);
  }

  //                       (blur)="onBlur()"
  onBlur() {

    this.beginScroll = false;
    this._items = [];
    this._itemsFiltered = [];
    this.comboBoxpagingationParams.currentItem = '0';
    var siteId = this._form.get('site').value;
    this._loadItemsDD(siteId.id);
  }

  _onUploadClick() {

    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }
  showSavedFailed(event: any) {

  }
  //#region  Search Doc
  /* _returnSelectedDocumentsHandler(e: any): void {
    this._selectedExistingFiles = [];
    this._selectedDocumentsKeys = [];
      if (this._currentUser.isEnterprise) {
          if (this._selectedAccounts.length) {
              this._showDocumentsGrid = false;
              let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
              this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
                  return currentSelected.indexOf(c) === index;
              });
          } else {
              this._layoutComponent.openPopup({
                  title: 'Validation',
                  message: 'Please choose the account with the site desired',
                  withoutConfirm: true
              });
          }
      }
      else if (!this._currentUser.isEnterprise) {
          this._showDocumentsGrid = false;
          let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
          this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
              return currentSelected.indexOf(c) === index;
          });
          this._selectedDocumentsKeys.forEach((v) => {
            let _selectedFileModel:FileSelectedStream = <FileSelectedStream>({
              stream : '',
              size :0,
              type : '',
              name : '',
              fileSource : fileSources.purchaseOrder,
              isNew : false,
              existingFileId: v
            });
            this._selectedExistingFiles.push(_selectedFileModel);

            this._uploaderSelectMessage = 'Upload file..' + ` [ ${this._selectedExistingFiles.length} file(s) selected ]`;
          });
          //this._addPurchaseOrderDocument();
      }
  } */

  /* _addPurchaseOrderDocument() {
      this._stockItemFilesDocs = this._stockItemFilesDocs === null ? [] : this._stockItemFilesDocs;

      if (this._selectedObjectDocuments.length > 0) {
          this._selectedObjectDocuments.forEach((element: any) => {
              let stockItemFile: SalesOrderFile = new SalesOrderFile();
              stockItemFile.fileId = element.id;
              stockItemFile.fileName = element.name;
              stockItemFile.file = element;
              this._stockItemFilesDocs.push(stockItemFile);
          });
      }
  }
  _closeDocumentsWindow(): void {
      this._showDocumentsGrid = false;
  }
  _selectImagesHandler(e: any): void {
      if (this._currentUser.isEnterprise) {
          if (this._selectedAccounts.length) {
              this._showDocumentsGrid = true;
          } else {
              this._layoutComponent.openPopup({
                  title: 'Validation',
                  message: 'Please choose the account with the site desired',
                  withoutConfirm: true
              });
          }
      }
      else if (!this._currentUser.isEnterprise) {
          this._showDocumentsGrid = true;
      }
  }

  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
      return this._filesService.getAllDocuments(this._selectedAccounts, params, model);
  } */

  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  }
  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  //#endregion

  // #region File Library
  //Images / Picutres
  _getFilesGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._filesPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._filesPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._filesPageName, (gridColumns) => {
      this._filesGridFields = gridColumns;
    });
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._filesGridFields == undefined || this._filesGridFields.length == 0) {
        this._getFilesGridFields();
      }
      this._showImagesGrid = true;
    }
  }
  _closeImagesWindow(): void {
    this._showImagesGrid = false;
    this._isDialiog = false;
  }
  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = false;
        this._selectedImagesKeys = this._selectedImages;
        this._addPicture();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
      this._addPicture();
    }
  }
  _addPicture(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesPics =
        this._purchaseOrderFilesPics === null ? [] : this._purchaseOrderFilesPics;
      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._purchaseOrderFilesPics.find(f => f.fileId == element.id);
          if (exists == undefined) {
            delete element.fileAccounts;
            let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesPics.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        stockPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesPics.push(addedFileItem);
    }
  }
  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }
  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }
  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this._selectedAccountIds,
      params,
      model
    );
  };
  _setPrimaryPic(data: any) {
    this._purchaseOrderFilesPics.forEach((element: stockPurchaseOrderFile) => {
      if (element !== data) {
        element.purchaseOrderFileisPrimary = false;
      }
      else {
        element.purchaseOrderFileisPrimary = true;
      }
    });
  }
  _removePicHandler(event: any) {
    const index = this._purchaseOrderFilesPics.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesPics.splice(index, 1);
      this._selectedImagesKeys.splice(this._selectedImagesKeys.indexOf(event), 1);
    }
  }
  _removeFileFromLibrary(event: stockPurchaseOrderFile) {
    //Delete Logic Goes Here
    this._removePicHandler(event);

  }
  _onSelectedImagesChanged(e: any[]) {
  }
  _onSelectedImagesRowChanged(e: any[]) {
  }
  //Documents
  _getDocumentsGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._documentsPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._documentsPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._documentsPageName, (gridColumns) => {
      this._documentsGridFields = gridColumns;
    });
  }
  _selectDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._documentsGridFields == undefined || this._documentsGridFields.length == 0) {
        this._getDocumentsGridFields();
      }
      this._showDocumentsGrid = true;
    }
  }
  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }
  _returnSelectedDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = false;
        this._selectedDocumentsKeys = this._selectedDocuments;
        this._addDocument();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      this._selectedDocumentsKeys = this._selectedDocuments;
      this._addDocument();
    }
  }
  _addDocument(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesDoc =
        this._purchaseOrderFilesDoc === null ? [] : this._purchaseOrderFilesDoc;

      if (this._selectedObjectDocuments.length > 0) {
        this._selectedObjectDocuments.forEach((element: any) => {
          let exists = this._purchaseOrderFilesDoc.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesDoc.push(addedFileItem);
          }
        });
      }
    }
    else {
      const docId = fileData.picObject?.id || fileData.response?.id || fileData.response?.responseId;
      if (docId) {
        let exists = this._purchaseOrderFilesDoc.find(f => f.fileId == docId && f.status == EntityStatusOptions.Active);
        if (exists == undefined) {
          let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
            fileId: docId,
            file: fileData.picObject?.file || fileData.picObject || fileData.response,
            stockPurchaseOrderId: this._model.id ? this._model.id : 0,
            status: EntityStatusOptions.Active,
          });
          this._purchaseOrderFilesDoc.push(addedFileItem);
        }
      }
    }
  }
  _removeDocHandler(event: any) {
    const index = this._purchaseOrderFilesDoc.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesDoc.splice(index, 1);
      this._selectedDocumentsKeys.splice(this._selectedDocumentsKeys.indexOf(event), 1);
    }
  }
  _onDocumentsRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }
  _onDocumentObjectRowSelectionChange(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  };
  _doDownloadFile(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  //Videos
  _getVideosGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._videosPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._videosPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._videosPageName, (gridColumns) => {
      this._videosGridFields = gridColumns;
    });
  }
  _selectVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._videosGridFields == undefined || this._videosGridFields.length == 0) {
        this._getVideosGridFields();
      }
      this._showVideoGrid = true;
    }
  }
  _closeVideosWindow(): void {
    this._showVideoGrid = false;
  }
  _returnSelectedVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = false;
        this._selectedVideosKeys = this._selectedVideos;
        this._addVideo();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVideoGrid = false;
      this._selectedVideosKeys = this._selectedVideos;
      this._addVideo();
    }
  }
  _addVideo(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesVideo =
        this._purchaseOrderFilesVideo === null ? [] : this._purchaseOrderFilesVideo;

      if (this._selectedObjectVideos.length > 0) {
        this._selectedObjectVideos.forEach((element: any) => {
          let exists = this._purchaseOrderFilesVideo.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesVideo.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: stockPurchaseOrderFile = <stockPurchaseOrderFile>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        stockPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesVideo.push(addedFileItem);
    }
  }
  _removeVideoHandler(event: any) {
    const index = this._purchaseOrderFilesVideo.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesVideo.splice(index, 1);
      this._selectedVideosKeys.splice(this._selectedVideosKeys.indexOf(event), 1);
    }
  }
  _onVideosRowSelectionChanges(e: any[]) {
    this._selectedVideos = [];
    e.forEach((item) => {
      this._selectedVideos.push(+item);
    });
  }
  _onVideoObjectRowSelectionChange(e: any[]) {
    this._selectedObjectVideos = [];
    this._selectedObjectVideos = e;
  }
  _getAccountVideos = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getVideos(params, model);
  };
  _doDownloadVideo(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  // #endregion
  //#region Multi Site Functions
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites()

      .subscribe((data: any) => {
        this._sites = data || [];
        this._sitesFiltered = this._sites;

        this.initAllSitesDropDown(IsEdit, SavedSite);

      });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this._form.controls['site'].setValue(this._siteSelected);
    this._loadVendorsDD(this._form.controls['site'].value?.id);
    this.getStockItemDDPaging(this._form.controls['site'].value?.id);
    this._loadAddressesDD(this._form.controls['site'].value?.id);
  }
  // _handleSitesFilter(value: any) {
  //   this._sitesFiltered = this._sites.filter(
  //     (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
  //   );
  // }
  // _handleSitesChange(event: any)
  // {
  //   this._siteSelected = event;
  //   //this._loadLocationsDD(this._siteSelected?.id);
  //   this._loadVendorsDD(this._siteSelected?.id);
  //   this.getStockItemDDPaging();
  // }
  _handleSitesChange(event: any) {
    let _currentVal = this._form.value.site;


    setTimeout(() => {
      if (this._inventoryGridData.length > 0 || this._form.controls['vendor'].value
        || this._form.controls['address'].value
      ) {
        if (confirmSiteSub)
          confirmSiteSub.unsubscribe();
        var confirmSiteSub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
          if (data == true) {
            this._inventoryGridData = [];
            this._selectedStockItem.setValue(null);
            this._form.controls['vendor'].setValue(null);
            this._form.controls['address'].setValue(null);
            this._siteSelected = event;
            this._form.controls['site'].setValue(event);
            this._loadVendorsDD(this._form.controls['site'].value?.id);
            this.getStockItemDDPaging(this._form.controls['site'].value?.id);
            this._loadAddressesDD(this._form.controls['site'].value?.id);
          }
          else {
            this._form.patchValue({
              site: _currentVal
            });
          }
        });
        this._layoutComponent.openPopup({
          title: 'Notification',
          message: `Changing the site will clear the selected items,vendor,address of the transaction. Continue?`
        });
      }
      else {
        this._form.controls['site'].setValue(event);
        this._selectedStockItem.setValue(null);
        this._form.controls['vendor'].setValue(null);
        this._form.controls['address'].setValue(null);
        this._siteSelected = event;
        this._loadVendorsDD(this._form.controls['site'].value?.id);
        this.getStockItemDDPaging(this._form.controls['site'].value?.id);
        this._loadAddressesDD(this._form.controls['site'].value?.id);
      }
    }, 100);
  }
  //#endregion
  _showVendorNotesWindow(id: number) {
    this._vendorsService.getVendor(id)

      .subscribe((model: any) => {
        this._vendorNotesModel = model;
        this._showVendorFileNotes = true;
      });
  }
  _closeVendorNotesWindow() {
    this._showVendorFileNotes = false;
  }
  getMarkupType(obj: any, propString: any) {

    if (obj.costInfo.isCalculatedPrice)
      return "Calclulated Price"
    else if (obj.costInfo.isFixedPrice)
      return "Fixed Price"
  }
  displayCatImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.categoryFilePrimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }
    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }
  displayStockImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.stockitemfileisprimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }

    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }
  getAccountNames(accounts: any[]): string {
    if (!accounts || !Array.isArray(accounts)) return '';
    const names = accounts
      .map(d => d?.account?.name ?? d?.name)
      .filter((name): name is string => typeof name === 'string' && name.trim().length > 0);
    return Array.from(new Set(names)).join(', ');
  }
  _closeStockItemNotesWindow() {
    this._showStockItemFileNotes = false;
  }
  _showStockItemNotesWindow(id: number) {
    this._stockItemsService.getStockItem(id)

      .subscribe((model: any) => {
        this._stockItemNotesModel = model;
        this._showStockItemFileNotes = true;
      });
  }
}
